var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceIconCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_checkbox_bg",
    stroke: "#BAC3CF",
    d: "M26.5 16C26.5 21.799 21.799 26.5 16 26.5C10.201 26.5 5.5 21.799 5.5 16C5.5 10.201 10.201 5.5 16 5.5C21.799 5.5 26.5 10.201 26.5 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_checkbox_check",
    fill: "#BAC3CF",
    d: "M21.0216 12.461C21.3192 12.7491 21.327 13.2239 21.039 13.5216L15.041 19.7195C14.8983 19.867 14.7014 19.9495 14.4961 19.9479C14.2909 19.9463 14.0953 19.8606 13.9549 19.7109L10.9529 16.5088C10.6696 16.2067 10.6849 15.732 10.987 15.4487C11.2892 15.1654 11.7638 15.1807 12.0471 15.4829L14.5107 18.1106L19.961 12.4784C20.2491 12.1808 20.7239 12.173 21.0216 12.461Z"
  })));
}
export default SvgPlaceIconCheckbox;